export default "__VITE_ASSET__CXpK96PE__"